// @flow

import React from 'react';

import { ModalManager } from 'react-dynamic-modal';

import Select from 'react-select';
import _ from 'underscore';

import Tbutton from './Tbutton';
import Tinput from './Tinput';
import Tcheckbox from './Tcheckbox';

import ConfigActions from '../actions/ConfigActions';
import ActiveConfigActions from '../actions/ActiveConfigActions';
import ConfigStore from '../stores/ConfigStore';
import ActiveConfigStore from '../stores/ActiveConfigStore';
import NotificationModal from './NotificationModal';

import SchemaActions from "../actions/SchemaActions";
import SchemaStore from "../stores/SchemaStore";

import t from '../trans';

import SchemaFactory from "../SchemaFactory";
import PropTypes from "prop-types";
import rootStore from "../stores";

const propTypes = {
	session: PropTypes.object
};

class Config extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			config: ConfigStore.getState(),
			activeConfig: ActiveConfigStore.getState(),
			configSchema: this.getConfigSchema()
		};

		this.onChange = this.onChange.bind(this);
		this.onChangeActiveConfig = this.onChangeActiveConfig.bind(this);
		this.onChangeSchema = this.onChangeSchema.bind(this);
		this.onClickLoad = this.onClickLoad.bind(this);
		this.onClickSave = this.onClickSave.bind(this);

		this.onValueChanged = this.onValueChanged.bind(this);
	}

	componentDidMount() {
		ConfigStore.listen(this.onChange);
		ActiveConfigStore.listen(this.onChangeActiveConfig);
		SchemaStore.listen(this.onChangeSchema);

		SchemaActions.fetchSchema("config");

		ConfigActions.fetchConfig();
	}

	componentWillUnmount() {
		ConfigStore.unlisten(this.onChange);
		ActiveConfigStore.unlisten(this.onChangeActiveConfig);
		SchemaStore.unlisten(this.onChangeSchema);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.config.state === "PROCESSING" && this.state.config.state !== "PROCESSING") {
			// Configuration loading or saving finished
			// Load active configuration too:
			if (this.state.activeConfig.state !== "PROCESSING") ActiveConfigActions.fetchConfig.defer();
		}
	}

	onChange(state) {
		this.setState({
			config: _.clone(state)
		});
	}

	onChangeActiveConfig(state) {
		this.setState({
			activeConfig: _.clone(state)
		});
	}

	onChangeSchema(state) {
		if (state.schemas.config != null) {
			this.setState({
				configSchema: state.schemas.config
			});
		}
	}

	onValueChanged(param, value) {
		let schema = this.getItemSchema(param);

		switch (schema.type) {
			case "string":
			default:
				if (value === "") value = null;
		}
		ConfigActions.changeValue(param, value);
	}

	onClickLoad() {
		ConfigActions.fetchConfig();
	}

	onClickSave() {
		this.askConfirmation(t("Save configuration")+"?", function () {
			ConfigActions.saveConfig.defer();
		});
	}

	askConfirmation(message, func) {
        ModalManager.open(<NotificationModal title={t("Confirmation")} onClickOk={function() {
            func();
            ModalManager.close();
        }} okText={t('OK')} cancelText={t('Cancel')}>{message}</NotificationModal>);
    }

	render() {
		return (
			<div className="container-fluid">
				<div className="row">
					<div className="col-md-2">
						<Tbutton className="btn btn-primary" onClick={this.onClickSave}>Save configuration</Tbutton>
					</div>
					<div className="col-md-2">
						<Tbutton className="btn btn-primary" onClick={this.onClickLoad}>Reload configuration</Tbutton>
					</div>
				</div>
				<form className="form-horizontal">
					<table className="table table-hover">
						<thead>
							<tr>
								<th className="col-sm-2">{t("Parameter")}</th>
								<th className="col-sm-6">{t("Value in configuration file")}</th>
								<th className="col-sm-4">{t("Current effective value")}</th>
							</tr>
						</thead>
						<tbody>
							{this.renderConfigItems()}
						</tbody>
					</table>
				</form>
				<div className="row">
					<div className="col-md-2">
						<Tbutton className="btn btn-primary" onClick={this.onClickSave}>Save configuration</Tbutton>
					</div>
				</div>
			</div>
        );
	}

	renderConfigItems() {
		let configItems = this.getConfigItems();

		let result = [];
		for (let item of configItems) {
			let renderedItem = this.renderConfigItem(item);
			if (renderedItem != null) result.push(renderedItem);
		}
		return result;
	}

	renderConfigItem(item) {
		let itemInfo = this.getConfigItemInfo(item);
		if (itemInfo == null) return null;

		let renderedItem = null;
		switch (itemInfo.type) {
			case "boolean":
				renderedItem = this.renderFormBoolean(itemInfo);
				break;
			case "select":
				renderedItem = this.renderFormSelect(itemInfo);
				break;
			case "integer":
				renderedItem = this.renderFormInteger(itemInfo);
				break;
			case "string":
			default:
				renderedItem = this.renderFormText(itemInfo);
				break;
		}
		return (
			<tr key={itemInfo.name}>
				<td>{t(itemInfo.title)}</td>
				<td>
					{renderedItem}
					{this.renderHelp(itemInfo)}
				</td>
				<td>
					{this.renderActiveValue(itemInfo)}
				</td>
			</tr>
		);
	}

	renderFormBoolean(item) {
		return (
			<Tcheckbox className="form-control" id={item.name} checked={(this.state.config.config[item.name] == null ? false : this.state.config.config[item.name])} value={true} onClickParam={item.name} onClick={this.onValueChanged}>{item.title}</Tcheckbox>
		);
	}

	renderFormSelect(item) {
		let selectedValue = _.find(item.options, function (o) {
			return o.value === (this.state.config.config[item.name] === undefined ? null : this.state.config.config[item.name]);
		}.bind(this));
        if (selectedValue == null) selectedValue = "";
		return (
			<Select options={item.options} id={item.name} name={item.name} value={selectedValue} onChange={(o, action) => this.onValueChanged(item.name, o.value)} style={{width: 400}}/>
		);
	}
	/**
	 *
	 * @param item
	 * @returns {*}
	 */
	renderFormText(item) {
		return (
			<Tinput className="form-control" id={item.name} type="text" valueType="string" value={this.state.config.config[item.name] == null ? "" : this.state.config.config[item.name]} onChange={this.onValueChanged} onChangeParam={item.name} />
		);
	}

	renderFormInteger(item) {
		return (
			<Tinput className="form-control" id={item.name} type="text" valueType="integer" value={this.state.config.config[item.name] == null ? "" : this.state.config.config[item.name]} onChange={this.onValueChanged} onChangeParam={item.name} />
		);
	}

	renderHelp(item) {
		return (
			<p className="help-block">{t(item.description)} {item.default ? " (" + t("default value") + ": \"" + item.default + "\")": null}</p>
		);
	}

	renderActiveValue(item) {
		if (item.writeOnly) return null;
		if (item.type == "boolean") {
			return (this.state.activeConfig.config[item.name] ? t("checked") : t("unchecked"));
		}
		return this.state.activeConfig.config[item.name]
	}

	getConfigItemInfo(item) {
		let schema = this.getItemSchema(item);
		if (schema == null) return null;

		let itemInfo = {
			name: item,
			title: schema.title,
			description: schema.description,
			type: schema.type,
			default: schema.default,
			readOnly: schema.readOnly,
			writeOnly: schema.writeOnly
		};
		if (schema.enum) {
			itemInfo.type = "select";
			itemInfo.options = [{value: "", label: ""}];
			for (let i = 0; i < schema.enum.length; i++) {
				itemInfo.options.push({
					value: schema.enum[i],
					label: (schema.enumNames ? schema.enumNames[i] : schema.enum[i].toString().charAt(0).toUpperCase() + schema.enum[i].toString().substring(1).toLowerCase())
				});
			}
		}
		return itemInfo;
	}

	getItemSchema(item) {
		return this.state.configSchema.properties[item];
	}

	getConfigItems() {
		return this.state.configSchema.order;
	}

	getConfigSchema() {
		let schemaFactory = SchemaFactory.getInstance();
		return schemaFactory.getSchema("config");
	}
}

Config.propTypes = propTypes;

export default Config;
